export function dateToIsoMonthString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}

export function isoMonthStringToDate(isoMonthString: string): Date {
  return new Date(`${isoMonthString}-01T00:00`);
}
